import React from 'react';
import Rater from 'react-rater';
import { WhitePanelLayout } from '@dom/components';

import reviews from './staticReviewsData.json';

const AllReviews = ({isMobile = false}) => {
  return (
    <WhitePanelLayout className={`reviews-box fullReviewSection`}>
      <h2 id="fullReviewSection">Reviews</h2>
      <ul className="recent-comments">
        {
          reviews.map(r => <Review data={r} key={r.review} />)
        }
      </ul>
    </WhitePanelLayout>
  );
}

const SidebarReviews = () => {
  return (
    <WhitePanelLayout className="reviews-box">
      <h2>Recent Reviews
        <span className="alink"><a href="#fullReviewSection">See all</a></span>
      </h2>
      <ul className="recent-comments">
        {
          reviews.slice(0, 3).map(r => <Review data={r} key={r.review} />)
        }
      </ul>
    </WhitePanelLayout>
  );
}

function Review({ data: { trekkerName, rating, review, guideName, link } }) {
  return (
    <li>
      {/* <div className="image">
        <img src="https://s3.amazonaws.com/honeyguide/assets/user-fallback.png" alt="" />
      </div> */}
      <div className="comment">
        <h5>{trekkerName}</h5>
        <Rater total={5} rating={rating} interactive={false} />
        <p>{review}</p>
        <h6>Guide Name: <a href={link} target="_blank" rel="noreferrer noopener">{guideName}</a></h6>
      </div>
    </li>
  );
}
export { AllReviews, SidebarReviews };
